import { combineReducers } from 'redux';
// 新版流程
import outSupplierManagement from './outSupplierManagement';
import outWorkbench from './outWorkbench';
import outProjectDetail from './outProjectDetail';

// 账户
import account from './account';
import menuCount from './menuCount';

// 社媒组
import workbench from './workbench';
import smProjectDetail from './smProjectDetail';
import smSupplierManagement from './smSupplierManagement';

// 直播组
import lsWorkbench from './lsWorkbench';
import lsProjectDetail from './lsProjectDetail';
import lsSupplierManagement from './lsSupplierManagement';



// 招采
import bidWorkbench from './bidWorkbench';
import bidProjectDetail from './bidProjectDetail';

export default combineReducers({
  account,
  menuCount,
  // 社媒组
  workbench,
  smProjectDetail,
  smSupplierManagement,
  // 直播组
  lsWorkbench,
  lsProjectDetail,
  lsSupplierManagement,
  // 新版流程
  outSupplierManagement,
  outWorkbench,
  outProjectDetail,
  // 招采
  bidWorkbench,
  bidProjectDetail,
});
